import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { constant } from './../../constants/app.constants';
import { UserModel } from '../../modules/myPrimeRx/models/user.model'; 
import { Router } from '@angular/router'; 
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../environments/environment';

import {PatientEngagementService} from '../../../../src/app/modules/myPrimeRx/services/patient-engagement.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}; 

@Injectable({
  providedIn: 'root'
})
export class PeAuthService {

  public _activeElinkUserSub$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public elinkData$: Observable<any> = this._activeElinkUserSub$.asObservable();
  elinkData: any;
  elinkParams: any;
  private isLoggingOut = false;

  constructor(
    private http: HttpClient,
    private _router: Router,
    private _authService: AuthService,
    public _patientEngagementService: PatientEngagementService,
  ) {}

  getElinkData(id: string, guid: string, npi: string): Observable<any> {
    const url = environment.API_BASE_URL + constant.ELINK_GET
      .replace("{id}", "" + id)
      .replace("{guid}", "" + guid)
      .replace("{npi}", "" + npi);
    return this.http.get<any>(url);
  }
  
  async logout(): Promise<void> {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;

    try {
      localStorage.setItem('logout-event', Date.now().toString());

      await this.updatePatientLoginStatus();
      this._activeElinkUserSub$.next(null);
    } catch (error) {
      console.error('[PeAuthService] Error during logout prep:', error);
    }

    setTimeout(() => {
      const lastEmail = localStorage.getItem('lastLoginEmail');
      const logoutEvent = localStorage.getItem('logout-event');
      localStorage.clear();
      sessionStorage.clear();
      // Preserve these after clear so other contexts (browser/PWA) can detect the logout
      if (lastEmail) {
        localStorage.setItem('lastLoginEmail', lastEmail);
      }
      if (logoutEvent) {
        localStorage.setItem('logout-event', logoutEvent);
      }

      this._authService.logout({
        logoutParams: { returnTo: window.location.origin }
      }).subscribe({
        error: () => {
          this.isLoggingOut = false;
          this._router.navigate(['/login']);
        },
        complete: () => {
          this.isLoggingOut = false;
          this._router.navigate(['/login']);
        }
      });
    }, 100);
  }

  async updatePatientLoginStatus() {
    console.log("Updating patient login status to false.");
    const elinkRaw = localStorage.getItem("eLinkData");
    this.elinkData = (elinkRaw && elinkRaw !== 'undefined') ? JSON.parse(elinkRaw) : {};

    const paramsRaw = localStorage.getItem('paramsData');
    this.elinkParams = (paramsRaw && paramsRaw !== 'undefined') ? JSON.parse(paramsRaw) : null;

    if (this.elinkData?.EntityId && this.elinkParams?.npi) {
      const payload: any = {
        "PatientId": this.elinkData.EntityId,
        "npi": this.elinkParams.npi,
        "isLoggedIn": false
      };
      console.log("Payload for updating patient status:", payload);
      try {
        const result = await firstValueFrom(this._patientEngagementService.updatePatientLoginStatus(payload));
        if (result) {
          return result;
        }
      } catch (error) {
        console.error("Update patient status failed:", error);
      }
    } else {
      console.log("Required data is missing: PatientId or npi is undefined.");
    }
    return true;
  }
}
